import React, { useContext } from 'react';
import { compact, isEmpty, find } from 'lodash';
import { routes } from 'constants/config';
import searchImg from 'images/search.svg';
import { FilterContext } from 'components/shared/FilterContext';
import DataCardHeader from '../_shared/DataCardHeader';
import Count from '../_shared/Count';
import TopSearches from './TopSearches';
import SearchesOverTimeChart from './SearchesOverTimeChart';
import DateRangeFormat from '../_shared/DateRangeFormat';

const SearchModule = ({ i18n }) => {
  const { params: filterParams } = useContext(FilterContext);
  const hasDateFilter = filterParams.start_date || filterParams.end_date;
  const hasGroupFilter = !isEmpty(filterParams.group_ids);

  const totalCountTooltip = find([
    hasDateFilter &&
      hasGroupFilter &&
      t('insights.searches.total_count.description_with_all_filters'),
    hasDateFilter &&
      !hasGroupFilter &&
      t('insights.searches.total_count.description_with_date_filter'),
    !hasDateFilter &&
      hasGroupFilter &&
      t('insights.searches.total_count.description_with_group_filter'),
    t('insights.searches.total_count.description'),
  ]);

  return (
    <section className="DataCard mb-24">
      <DataCardHeader
        title={i18n.searches.total_count.title}
        tooltip={totalCountTooltip}
        subtitle={
          filterParams.start_date || filterParams.end_date ? (
            <DateRangeFormat
              start={filterParams.start_date}
              end={filterParams.end_date}
            />
          ) : (
            i18n.timeframes.last_90_days
          )
        }
        downloadLink={compact([
          routes.INSIGHTS.SEARCH.REPORT,
          $.param(filterParams),
        ]).join('?')}
        reportTitle={i18n.searches.report.title}
      >
        <Count
          route={routes.INSIGHTS.SEARCH.COUNT}
          imgSrc={searchImg}
          imgDescription={`${i18n.searches.total_count.title}:`}
        />
      </DataCardHeader>
      <div className="DataCard-main">
        <SearchesOverTimeChart i18n={i18n} />
        <div className="d-f jc-sb mt-32">
          <TopSearches i18n={i18n} />
          <TopSearches noResults i18n={i18n} />
        </div>
      </div>
    </section>
  );
};

export default SearchModule;
